import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { GET_JOB_OFFER } from '@gql/jobs';
import JobOfferForm from '@modules/JobOffers/forms/JobOfferForm';

const Container = styled(Box)({
    minHeight: 'calc(100dvh - 118px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    overflowY: 'auto',
});

const JobOfferEditModule = () => {
    const { slug } = useParams<{ slug: string }>();
    const navigate = useNavigate();

    const { data, loading, error } = useQuery(GET_JOB_OFFER, {
        variables: { jobNumber: slug, showInactive: true },
        skip: !slug,
    });

    const jobOffer = data?.getJobOffer;

    if (loading) {
        return (
            <Container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    if (error || (!loading && !jobOffer)) {
        return (
            <Container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Typography color="error">{error?.message ?? "Offre d'emploi introuvable."}</Typography>
            </Container>
        );
    }

    return (
        <Container>
            <JobOfferForm
                proId={jobOffer?.pro?._id}
                jobOffer={jobOffer}
                onSuccess={() => navigate('/job-offers')}
                onError={() => {}}
            />
        </Container>
    );
};

export default JobOfferEditModule;
